import { createCommand } from '@atlassian/rovo-content-bridge-api';

/**
 * Data payload for creating a Confluence page.
 */

/**
 * Properties for the Confluence page creation command.
 *
 * @extends CommandProperties
 */

/**
 * A command sent by a bridge API client to create a new Confluence page.
 *
 * @summary {@link CommandProperties.senderId} is requesting {@link CommandProperties.receiverId} to create a Confluence page with the specified content.
 */
export var ConfluencePageCreateCommand = createCommand('confluence-page-create-command');